import { configureScope, init, captureException } from '@sentry/browser';
import { Dedupe } from '@sentry/integrations';

const { sentry, customer } = window.PxlApp;
const { theme } = Shopify;

export const withSentry = (app) => {
  configureScope((scope) => {
    if (customer) scope.setUser({ id: customer.id });
    scope.setTag('theme', theme.name);
  });

  init({
    dsn: sentry.dsn,
    release: `${__NAME__}@${__VERSION__}`,
    environment: __PROD__ ? 'production' : 'development',
    integrations: [new Dedupe()]
  });

  try {
    app();
  } catch (error) {
    captureException(error);
    console.error(error);
  }
};
